import React from "react";
import StringUtils from "util/StringUtils";
const Pluralize = ({ value, singular, plural }) => /* @__PURE__ */ React.createElement("span", null, StringUtils.pluralize(value, singular, plural));
export default Pluralize;
